import React, { useState } from "react";
import Header from "../../components/header/Header";
import styles from "./ForgotPasswordPage.module.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import InputField from "../../components/inputField/InputField";
import Button from "../../components/button/Button";
import { apiUrl } from "../../constants";

const ForgotPasswordPage = () => {
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [displayform, toggleDisplayForm] = useState(true);
  const [success, toggleSuccess] = useState(false);

  const showNavigation = false;

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  // Send the email data to the database to reset the password (the database will send an email).
  async function onSubmit(data) {
    toggleErrorMessage(false);
    toggleLoading(true);
    try {
      const result = await axios.post(`${apiUrl}/auth/password/reset`, data);
      toggleDisplayForm(false);
      toggleSuccess(true);
    } catch (e) {
      toggleErrorMessage(true);
    }
    toggleLoading(false);
  }

  return (
    <div>
      <Header showNavigation={showNavigation} />
      <div className={styles.page}>
        <div className={styles.container}>
          {displayform && (
            <article>
              <h1>Reset Password</h1>
              <form
                className={styles["reset-form"]}
                onSubmit={handleSubmit(onSubmit)}
              >
                <section>
                  <InputField
                    label="Email"
                    fieldRef={register("email", { required: true })}
                    name="email"
                    type="text"
                    id="email-sign-in-field"
                  />
                  {errors.email && (
                    <p className={styles.error}>Email is required</p>
                  )}
                </section>

                <section>
                  <Button type="submit">RESET PASSWORD</Button>
                </section>
              </form>

              {errorMessage && (
                <div className={styles["error-wrapper"]}>
                  <span className={styles.error}>
                    Something went wrong with requesting a new password, please
                    try again later.
                  </span>
                </div>
              )}

              <div className={styles["loading-wrapper"]}>
                {loading && <p className={styles.loading}>Loading...</p>}
              </div>
            </article>
          )}

          {success && (
            <div className={styles["success-container"]}>
              <p>Thank you</p>
              <p>Please check your email for further instructions</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
